import { createFileRoute } from '@tanstack/react-router';

import {
  PageContentLayout,
  PageContentLayoutHeader,
  PageContentLayoutMain,
} from '@/components/layout';
import { AiRefereeSystemPromptSection } from '@/components/parameters';
import { CustomTitle } from '@/components/typography';

function ParametersScreen() {
  return (
    <PageContentLayout>
      <PageContentLayoutHeader>
        <CustomTitle level="h1">Parameters</CustomTitle>
      </PageContentLayoutHeader>
      <PageContentLayoutMain>
        <AiRefereeSystemPromptSection />
      </PageContentLayoutMain>
    </PageContentLayout>
  );
}

export const Route = createFileRoute('/_auth/parameters')({
  component: ParametersScreen,
});
